<div class="mx-3">
    @for (cat of getCategories(); track cat) {
    <section class="category-section my-4">
        <header class="cat-header">
        <div class="flex items-center gap-2">
            <span class="cat-dot"></span>
            <h2 class="m-0">{{ cat }}</h2>
        </div>
        </header>

        <div class="grid">
        @for (page of pages; track page) {
            @if (page.category == cat) {
            <app-dashboard-card
                class="my-2 lg:col-3 col-6"
                [icon]="page.icon"
                [title]="page.title"
                [routerLink]="page.routerLink">
            </app-dashboard-card>
            }
        }
        </div>
    </section>
    }
</div>
